import React from 'react';
import PropTypes from 'prop-types';
import './checkbox.scss';

export default function ReactCheckbox({
  id,
  defaultChecked,
  name,
  value,
  label,
  onChange,
  className,
  disabled,
  checked,
  ...props
}) {
  return (
    <label
      className={`custom-check-box react ${className}${
        disabled ? ' disabled' : ''
      }`}
      htmlFor={id}
    >
      <input
        type="checkbox"
        id={id}
        value={value}
        name={name}
        defaultChecked={defaultChecked}
        onChange={onChange}
        disabled={disabled}
        checked={checked}
      />
      <span className="checkbox">&nbsp;</span>
      <ins className={className}>
        {label}
        {props.children}
      </ins>
    </label>
  );
}
ReactCheckbox.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string,
  defaultChecked: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onChange: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
};
ReactCheckbox.defaultProps = {
  label: '',
  id: '',
  value: '',
  name: '',
  defaultChecked: false,
  onChange: () => {},
  className: '',
  disabled: false,
  checked: false,
};
